import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';

import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import SupportCasesShell from './SupportCasesShell.vue';

// Required: routeIsAccessibleFor treats an empty permission list as "no one",
// so a route without this is unreachable for every user. ROLES must be included
// alongside the custom-role permissions, or plain agents and administrators are
// locked out. Visibility inside the surface is the server's permission scope —
// these permissions only decide who may open the screen at all.
const meta = {
  featureFlag: FEATURE_FLAGS.SUPPORT_CASES,
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
};

// The open case is a path segment keyed by display_id — the number agents quote
// — so a workroom is a shareable link. List filters stay query params on the
// index route for the same reason.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/cases'),
    name: 'support_cases_index',
    meta,
    component: SupportCasesShell,
  },
  {
    path: frontendURL('accounts/:accountId/cases/:displayId'),
    name: 'support_cases_show',
    meta,
    component: SupportCasesShell,
    props: route => ({ displayId: route.params.displayId }),
  },
];

export default { routes };
